var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    width: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u0430\u0439\u043B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    fill: "none",
    stroke: "#212121",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.75,
    y1: 6.75,
    x2: 7.75,
    y2: 6.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75,
    y1: 9.75,
    x2: 12.25,
    y2: 9.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75,
    y1: 12.75,
    x2: 12.25,
    y2: 12.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75,14.25V3.75c0-1.105,.895-2,2-2h5.586c.265,0,.52,.105,.707,.293l3.914,3.914c.188,.188,.293,.442,.293,.707v7.586c0,1.105-.895,2-2,2H4.75c-1.105,0-2-.895-2-2Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16,6.25h-3.41c-.552,0-1-.448-1-1V1.852",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileContent);
export default __webpack_public_path__ + "static/media/file-content.c75d54d137f70537d02c2a7bec0dd744.svg";
export { ForwardRef as ReactComponent };